import { StarIcon } from "lucide-react";

import { SheetSectionContainer, SheetSectionHeader } from "@/components";

import { Endorsement } from "@/types";

export const SheetEndorsements = ({
  endorsements,
}: {
  endorsements: Endorsement[];
}) => {
  // We don't show anything if there are no endorsements. This is intended!
  if (!endorsements.length) {
    return null;
  }

  return (
    <SheetSectionContainer>
      <SheetSectionHeader icon={StarIcon} title="Endorsements" />
      <div className="flex flex-col gap-8">
        {endorsements.map((endorsement: Endorsement, i) => {
          return (
            <div className="flex flex-col gap-1" key={i}>
              <p className="text-xs text-slate-600">
                {new Date(endorsement.createdAt).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
              </p>
              <div className="flex items-center justify-between">
                <p className="font-normal text-slate-600">
                  Technical experience
                </p>
                <div className="flex items-center gap-4">
                  <div className="h-2 w-[125px] rounded-full bg-slate-200">
                    <div
                      style={{
                        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                        width: `${(endorsement.technicalExperienceRating / 5) * 100}%`,
                      }}
                      className="h-2 rounded-full bg-primary-900"
                    ></div>
                  </div>
                  <p className="text-slate-600">
                    {endorsement.technicalExperienceRating}/5
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <p className="text-slate-600">Leadership</p>
                <div className="flex items-center gap-4">
                  <div className="h-2 w-[125px] rounded-full bg-slate-200">
                    <div
                      style={{
                        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                        width: `${(endorsement.leadershipRating / 5) * 100}%`,
                      }}
                      className="h-2 rounded-full bg-primary-900"
                    ></div>
                  </div>
                  <p className="text-slate-600">
                    {endorsement.leadershipRating}/5
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <p className="text-slate-600">Teamwork</p>
                <div className="flex items-center gap-4">
                  <div className="h-2 w-[125px] rounded-full bg-slate-200">
                    <div
                      style={{
                        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                        width: `${(endorsement.teamworkRating / 5) * 100}%`,
                      }}
                      className="h-2 rounded-full bg-primary-900"
                    ></div>
                  </div>
                  <p className="text-slate-600">
                    {endorsement.teamworkRating}/5
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </SheetSectionContainer>
  );
};
